import _ from 'lodash'
import {CLASSIC_LAYOUT_TYPE} from '../../constants'
import type {SingleComponentPluginFunction} from '../../types'
import type {ComponentWithResolvedDataItems} from '@wix/document-services-types'

export const unpack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    const layout = component.data.layout?.default
    if (layout?.type === CLASSIC_LAYOUT_TYPE) {
        component.structure.layout = _.omit(layout, 'type')
        delete component.data.layout
    }
}
